import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { AuthService } from '../../core/auth/auth.service';
import { AutoUnsubscribe } from '../../core/auto-unsubscribe';
import { AjsFrameService } from './ajs-frame.service';
import { LoginOptions, OAuthService } from 'angular-oauth2-oidc';
import { AsyncPipe } from '@angular/common';

@AutoUnsubscribe()
@Component({
  selector: 'app-ajs-frame',
  templateUrl: './ajs-frame.component.html',
  styleUrls: ['./ajs-frame.component.scss'],
  imports: [AsyncPipe],
})
export class AjsFrameComponent implements OnInit, AfterViewInit {
  subs = new SubSink();

  @ViewChild('containerFrame') containerFrame:
    | ElementRef<HTMLIFrameElement>
    | undefined;

  safeFrameSrc: SafeUrl = this.sanitzier.bypassSecurityTrustResourceUrl('');
  showContainerFrame = false;

  private _frameSrc = '';

  @Input()
  get frameSrc(): string {
    return this._frameSrc;
  }
  set frameSrc(frameSrc: string) {
    this.stateService.loaded.next(false);
    const tmp = (frameSrc && frameSrc.trim()) || '';

    if (tmp.startsWith('/')) {
      this._frameSrc = `.${tmp}`;
    } else {
      this._frameSrc = tmp;
    }

    this.safeFrameSrc = this.sanitzier.bypassSecurityTrustResourceUrl(
      this._frameSrc
    );

    this.showContainerFrame = true;
  }

  get stateService(): AjsFrameService {
    return this.ajsFrameService;
  }

  public get isAuthenticated(): Observable<boolean> {
    return this.authService.isAuthenticated();
  }

  constructor(
    private ajsFrameService: AjsFrameService,
    private authService: AuthService,
    private simapOAuthService: OAuthService,
    private sanitzier: DomSanitizer
  ) {}

  @HostListener('window:message', ['$event'])
  onMessage(ev: MessageEvent) {
    if (ev.data.type != undefined) {
      switch (ev.data.type) {
        case 'simapOAuth-initLoginFlow':
          this.simapOAuthService.initLoginFlow(
            ev.data.task + '-' + ev.data.oid
          );
          break;
        case 'simapOAuth-refreshToken':
          this.simapOAuthService.refreshToken();
          break;
        default:
          // console.log('MessageEvent', ev);
          break;
      }
    } else {
      switch (ev.data) {
        case '$viewContentLoaded-AnimationEnd':
          this.stateService.navigateCompleteEvent.emit();
          break;
        case '$viewContentLoaded-Layout':
          this.stateService.loaded.next(true);
          break;
        case 'registerDialogClosed':
          this.stateService.hide();
          this.showAjsContentDiv();
          break;
        default:
          // console.log('MessageEvent', ev);
          break;
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.containerFrame) {
      this.containerFrame.nativeElement.onload = this.frameOnLoad;
    }
  }

  private frameOnLoad(e: Event) {
    // method runs inside of iframe, "this" refers to the iframe not our OverlayIFrameComponent
    const iframe = this as unknown as HTMLIFrameElement;
    iframe.className = 'loaded';
    const content = iframe.contentDocument;

    // add cupcake specific styles to angularjs app
    if (content) {
      const head = content.querySelector('head');
      if (head) {
        head.innerHTML +=
          '<link rel="stylesheet" href="styles/css/cupcake-style.css" type="text/css"/>';
      }
    }
  }

  ngOnInit(): void {
    // listens on openRegisterDialogEvent and simulates button click event
    this.subs.sink = this.stateService.openRegisterDialogEvent.subscribe(() => {
      const registerDialogBtn =
        this.containerFrame?.nativeElement.contentDocument?.getElementById(
          'registerDialogBtn'
        );

      if (registerDialogBtn) {
        this.hideAjsContentDiv();
        registerDialogBtn.click();
      }
    });

    // listens on navigation events and updates <iframe src="">
    this.subs.sink = this.stateService.navigateEvent.subscribe(url => {
      this.frameSrc = url;
    });

    //TODO: add listener which indicates if ajs is loaded? could be usefull to disable register btn etc. during load
  }

  hideAjsContentDiv(): void {
    const contentDiv =
      this.containerFrame?.nativeElement.contentDocument?.getElementById(
        'content'
      );

    if (contentDiv) contentDiv.className = 'hidden';
  }

  showAjsContentDiv(): void {
    const contentDiv =
      this.containerFrame?.nativeElement.contentDocument?.getElementById(
        'content'
      );

    if (contentDiv) contentDiv.className = '';
  }
}
